export default {
    header: {
        forum: '云论坛',
        forumdetails: '详情',
        speakers: '大会嘉宾',
        speakersinfo: '嘉宾信息',
        companyinfo: '路演企业',
        news: '新闻资讯',
        views: '精彩回顾',
        faq: '常见问题',
        back: '返回',
        footprint: '足迹',
        login: '登录/注册',
        records: '我的观展足迹',
        Login: '登录',
        Loginsucess: '登录成功',
        Logout: '登出',
        logoutsucess: '登出成功',
        confirmLogoutTitle: '确认登出吗？',
        confirmLogoutYes: '确认',
        confirmLogoutNo: '取消'
    },
    home: {
        meetingtime: '会议时间',
        days: '天',
        hours: '时',
        minutes: '分',
        seconds: '秒',
        fordetails: '了解详情',
        exhibiton: '云展馆',
        forum: '云论坛',
        news: '媒体<br>中心',
        speakers: '大会嘉宾',
        partners: '合作伙伴',
        contact: '联系我们',
        more: '查看更多',
        all: '全部日程',
        tel: '联系我们',
        email: '邮箱',
        applets: '官方小程序',
        microstation: '微信公众号',
        subscription: 'i绵阳',
        notice: '请使用者仔细阅读',
        agreement: '用户协议',
        privacy: '隐私政策',
        statement: '大会声明',
        rightProtection: '知识产权保护',
        askme: '智能客服小科',
        visitors: '参观次数',
        people: '次',
        hosts: '主办单位',
        hostsInfo: '四川省发展和改革委员会<br>中共四川省委网络安全和信息化委员会办公室',
        undertake: '承办单位',
        undertakeInfo: '四川封面传媒有限责任公司',
        support: '支持单位',
        supportInfo: '封面传媒有限责任公司',
        hostsTechnology: '中华人民共和国科学技术部',
        hostsGovernment: '四川省人民政府',
        hostsTechnologyUrl: 'http://www.most.gov.cn/',
        hostsGovernmentUrl: 'http://www.sc.gov.cn/',
        activityStatus: '即将呈现 | 进行中... | 已结束',
        activityBtnStatus: '查看更多 | 点击进入 | 精彩回顾'
    },
    forum: {
        agenda: '论坛议程',
        guests: '重要嘉宾',
        schedule: '议程安排',
        status: '直播中 | 直播回放 | 直播结束',
        notice: '距离直播开始'
    },
    channel: {
        latest: '最新报道',
        special: '专题报道',
        more: '更多',
        source: '来源：',
        author: '作者：'
    },
    faq: {
        faq: '常见问题'
    },
    login: {
        phonePlaceholder: '手机号',
        verificationCode: '获取验证码',
        codePlaceholder: '请输入验证码',
        countdown: '已发送({seconds}s)',
        login: '提交',
        codefail: '获取验证码失败，稍候再试',
        enphone: '请输入手机号',
        phoneerr: '手机号格式不正确',
        encode: '请输入验证码',
        codeerr: '请输入6位数字',
        codeerr1: '验证码错误',
        agree: '未注册用户登录时将自动创建新账号<br>登录即代表您同意',
        agreement: '软件许可及用户协议',
        privacy: '隐私政策',
        accountNumber: '必填',
        isAccountNumber: '账号不存在',
        accountPassword: '密码不正确',
    },
    footprint: {
        title: '我的观展足迹',
        nostart: '大会未开始，暂无观展足迹~',
        nodata: '您还没有观展足迹，先去观展吧~',
        Watchexhibition: '去观展',
        sign: '登录后才能查看您的观展足迹~',
        login: '登录/注册',
        content1: '我从',
        content2: '开始云上观展',
        content3: '累计观展',
        content4: '次',
        content5: '逛了',
        content6: '个展馆',
        content13: '、',
        content7: '个展区',
        content8: '参观了',
        content9: '个展品',
        content10: '这是我最感兴趣的展品，停留了',
        content11: '秒',
        content12: '这个展品最热门，邀请你也来看看~',
        share: '分享我的观展足迹',
        code: '扫码观展',
        save: '长按图片保存',
        imgLoaing: '图片生成中...',
        imgerror: '图片生成失败'
    },
    load: {
        loading: '加载中...',
        more: '加载更多',
        nomore: '没有更多了'
    },
    default: {
        empty: '敬请期待...',
        connection: '网络连接失败，请检查网络后再试',
        failed: '加载失败，请稍后重试'
    },
    activity: {
        status: '即将呈现 | 进行中... | 已结束',
        btnStatus: '点击进入 | 精彩回顾'
    }
}
